import { BrandContacts } from '@ankorstore/api-internal/BrandContacts';
import { Brands } from '@ankorstore/api-internal/Brands';
import {
  CreateBrandContactPublicPurposesEnum2,
  CreateBrandContactPublicTypeEnum,
  GetApiInternalV1BrandsBrandIdData,
  GetApiInternalV1BrandsBrandIdPurposesEnum,
  UpdateBrandContactPublicTypeEnum,
} from '@ankorstore/api-internal/data-contracts';

export type BrandContactIncluded = Extract<
  NonNullable<GetApiInternalV1BrandsBrandIdData['included']>[number],
  { type: 'brand-contacts' }
>;

export interface FinanceBrandContact {
  id: string;
  email: string;
}

const brandContactsClient = new BrandContacts();

export const fetchFinanceBrandContact = async (brandUuid: string): Promise<BrandContactIncluded | null> => {
  try {
    const brandsClient = new Brands();
    const response = await brandsClient.getApiInternalV1BrandsBrandId({
      brandId: brandUuid,
      include: 'brand-contacts',
    });
    return (
      response.included?.find(
        (item): item is BrandContactIncluded =>
          item.type === 'brand-contacts' &&
          item.attributes.purposes.includes(GetApiInternalV1BrandsBrandIdPurposesEnum.Finance)
      ) ?? null
    );
  } catch {
    return null;
  }
};

export const createFinanceBrandContact = async (email: string): Promise<FinanceBrandContact> => {
  const response = await brandContactsClient.createBrandContactPublic({
    data: {
      type: CreateBrandContactPublicTypeEnum.BrandContacts,
      attributes: {
        email,
        purposes: [CreateBrandContactPublicPurposesEnum2.Finance],
      },
    },
  });
  return {
    id: response.data.id,
    email: response.data.attributes.email,
  };
};

export const updateBrandContactEmail = async (id: string, email: string): Promise<void> => {
  await brandContactsClient.updateBrandContactPublic(id, {
    data: {
      type: UpdateBrandContactPublicTypeEnum.BrandContacts,
      id,
      attributes: { email },
    },
  });
};

export const deleteBrandContact = async (id: string): Promise<void> => {
  await brandContactsClient.deleteBrandContactPublic(id);
};
